import { useMenu, useRange } from 'react-instantsearch';

// Use this component to add virtual filters to the search
// These are filters that can be controlled via the URL, but the user can't manipulate them via the UI
const VirtualFilters = () => {
  useMenu({ attribute: 'highlightedFeature' });
  useMenu({ attribute: 'capCode' });
  useMenu({ attribute: 'branchInfo.franchiseCodes' });
  useRange({
    attribute: 'registeredAt',
  });

  return null;
};

export default VirtualFilters;
